$(document).ready(function () {
    classMailChimpSelects();
});

function classMailChimpSelects() {
    $('.mailchimp-form select').each(function () {
        $(this).wrap('<div class="custom-select-wrapper"></div>');
        var customSelectIcon = '<span class="custom-select-icon"></span>';

        $(this).closest('.custom-select-wrapper').append(customSelectIcon);
    });
}